import { Button } from '@massilia/ui'
import { Link } from '@tanstack/react-router'
import { Check } from 'lucide-react'

import { formatPrice } from '@/utils/format-price'

interface DepositConfirmationSuccessProps {
  amountCents?: number
  reference?: string
}

export function DepositConfirmationSuccess({
  amountCents,
  reference,
}: DepositConfirmationSuccessProps) {
  const amountLabel = amountCents ? formatPrice(amountCents / 100) : undefined

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="bg-brand-100 flex h-16 w-16 items-center justify-center rounded-full">
        <Check className="text-brand-600 h-8 w-8" />
      </div>
      <div className="flex max-w-lg flex-col items-center gap-4 text-center">
        <div className="text-gray-light-900 text-2xl font-semibold">Acompte reçu !</div>
        <p className="text-gray-light-700 text-sm">
          {amountLabel ? `Votre acompte de ${amountLabel}` : 'Votre acompte'}
          {reference
            ? ` a bien été enregistré pour le dossier ${reference}.`
            : ' a bien été enregistré.'}{' '}
          Vous recevrez une confirmation par email sous peu. Vous pouvez suivre l&apos;état de votre
          réservation depuis votre espace client.
        </p>

        <div className="mt-2 flex flex-wrap justify-center gap-3">
          <Link to="/">
            <Button type="button">Mon espace client</Button>
          </Link>
          <Link to="/payer-acompte">
            <Button type="button" variant="outline">
              Payer un autre acompte
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}
